import React from 'react'
import Box from '@mui/material/Box'
import { EmtTypography, EmtTextarea } from 'emt-components-v2'

import AdditionalInformations, {
  AdditionalInformationsHandle,
} from '@/components/pages/pet-sitter/reservations/NewRequest/AdditionalInformations'

export type AdditionalInformationsValues = {
  walkBehaviors: string[]
  indoorCleanliness?: 'never' | 'rare' | 'often'
  indoorBehaviors: string[]
  timeAlone?: string
  housing?: string
  summary?: string
}

type Props = {
  isMobile: boolean
  service: string
  hasSelectedDog: boolean

  values: AdditionalInformationsValues
  setValues: React.Dispatch<React.SetStateAction<AdditionalInformationsValues>>

  description: string
  setDescription: (value: string) => void

  additionalInfosRef?: React.RefObject<AdditionalInformationsHandle>

  topContent?: React.ReactNode
  sx?: any
}

const AdditionalInformationsForm: React.FC<Props> = ({
  service,
  hasSelectedDog,
  values,
  setValues,
  description,
  setDescription,
  additionalInfosRef,
  topContent,
  sx,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '20px',
        position: 'relative',
        backgroundColor: '#fff',
        borderRadius: '16px',
        padding: '17px',
        ...sx,
      }}
    >
      {topContent}

      {/* Caractéristiques */}
      <AdditionalInformations
        ref={additionalInfosRef}
        values={values}
        setValues={setValues}
        service={service}
        hasSelectedDog={hasSelectedDog}
      />

      {/* Description */}
      <Box>
        <EmtTypography variant="body1" fontWeight="400">
          <b>
            Souhaitez-vous ajouter d’autres informations à propos de vos animaux (besoins spécifiques, précautions
            particulières, etc.) ou concernant le service dont vous avez besoin ?
          </b>{' '}
          (Optionnel)
        </EmtTypography>

        <EmtTypography variant="body2" fontWeight="400" sx={{ marginBottom: '10px' }}>
          Ceci nous aidera à trouver le pet sitter parfait.
        </EmtTypography>

        <EmtTextarea
          hideLabelOnClick
          maxLength={1000}
          sx={{ height: '110px', paddingRight: '70px' }}
          label="Ajoutez ici vos précisions."
          value={description}
          onChange={setDescription}
        />
      </Box>
    </Box>
  )
}

export default AdditionalInformationsForm
